import { render, staticRenderFns } from "./AuthRecorder.vue?vue&type=template&id=5053a068&scoped=true"
import script from "./AuthRecorder.vue?vue&type=script&lang=js"
export * from "./AuthRecorder.vue?vue&type=script&lang=js"
import style0 from "./AuthRecorder.vue?vue&type=style&index=0&id=5053a068&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5053a068",
  null
  
)

export default component.exports